import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=82dbd97c&scoped=true&"
var script = {}
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=82dbd97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dbd97c",
  null
  
)

export default component.exports